import React from 'react';
import Box from '@mui/material/Box';
import Main from 'layouts/Main';
import Container from 'components/Container';
import { Image } from './components';

const Announcement = () => {
    return (
        <Main>
            <Box>
                <Container>
                    <Image />
                </Container>
            </Box>
        </Main>
    );
};

export default Announcement;
